import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { ModelosActionsCell } from './ModelosActionsCell'
import { ModeloList } from '../../core/_models'
import { PlainHeader, sortableColumn, StackedCell, StatusBadge, TableColumn } from 'app/components'

export const modelosColumns = (t: TFunction): ReadonlyArray<TableColumn<ModeloList>> => [
  // Título com a descrição como apoio; os dois seguem ordenáveis.
  sortableColumn<ModeloList>({
    id: 'titulo',
    useQueryRequest,
    fields: [
      { field: 'titulo', label: t('cols.titulo') },
      { field: 'descricao', label: t('cols.descricao') },
    ],
    Cell: ({ row }: CellProps<ModeloList>) => (
      <StackedCell primary={row.original.titulo} secondary={row.original.descricao} />
    ),
  }),
  sortableColumn<ModeloList>({
    id: 'data',
    cellWidth: '160px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'data', label: t('cols.data') }],
    Cell: ({ row }: CellProps<ModeloList>) => (
      <StackedCell tabular primary={row.original.dataFormatada} />
    ),
  }),
  sortableColumn<ModeloList>({
    id: 'ativo',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.status') }],
    Cell: ({ row }: CellProps<ModeloList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<ModeloList>) => <ModelosActionsCell modelo={row.original} />,
  },
]
